import { MagnifyingGlassIcon, TextField } from '@execonline-inc/execonline-ui';
import { TranslationsContext } from '@execonline-inc/translations';
import { noop } from '@kofno/piper';
import { observer } from 'mobx-react';
import { translation } from '../../../../Translations';

interface Props {
  disabled: boolean;
}

function Search({ disabled }: Props) {
  return (
    <form className="flex gap-2 basis-5/12">
      <TranslationsContext.Consumer>
        {(ts) => (
          <TextField
            disabled={disabled}
            className="h-full rounded-md pl-3 pr-4 !shadow-none !outline-0"
            inputClassName="pl-0 border-none"
            placeholder={translation('Search in this collection')(ts)}
            startContent={<MagnifyingGlassIcon size="sm" />}
            autoFocus
            fullWidth
            onChange={noop}
          />
        )}
      </TranslationsContext.Consumer>
    </form>
  );
}

export default observer(Search);
